/* eslint-disable no-lonely-if */
import React, { useContext } from 'react';
import { ReactDateTimePicker } from '@mummssoftware/common-ui';
import { FormHelperText } from '@material-ui/core';
import { preventFutureTimesMoment, Nil } from '@mummssoftware/utils/utils';
import { dateToMoment } from '@mummssoftware/utils/dates';
import { VisitContext } from '../Context/contexts/VisitContext';
import { TextDiv } from '../../components';
import defaults from '../../translations/en.json';

type EditStartTimeProps = {
  startTime: Date | Nil;
  onChange: (d: Date) => void;
  /** Label left of the picker, as two sibling grid cells. */
  inline?: boolean;
};

export const EditStartTime = ({
  startTime,
  onChange,
  inline = false,
}: EditStartTimeProps) => {
  const { is30MinAgency } = useContext(VisitContext);

  const picker = (
    <ReactDateTimePicker
      inputMargin="0 0 4px 0"
      dateFormat="h:mm aa"
      showTimeSelectOnly
      inputWidth="5.5rem"
      selectedDate={startTime}
      onChange={onChange}
      filterTime={(time: Date) => preventFutureTimesMoment(dateToMoment(time))}
      timeIntervals={is30MinAgency ? 30 : 15}
    />
  );

  if (inline) {
    return (
      <>
        <TextDiv>{defaults.editStart}</TextDiv>
        <div className="edit-start-pickerDate-div">{picker}</div>
      </>
    );
  }
  return (
    <div style={{ margin: '0px 8px' }} className="edit-start-pickerDate-div">
      <FormHelperText id="component-helper-text">
        {defaults.editStart}
      </FormHelperText>
      {picker}
    </div>
  );
};

export default EditStartTime;
